import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MetaFormFragmentBase } from 'Components/UI/Meta/MetaForm/Components/MetaFormFragmentBase';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { FDStack } from '@facet-wealth/design';
import { phaseOverrides } from './phaseOverrides';
import { PlanSummaryPhase } from './phaseLayout';

export const PlanSummaryPhases = ({ resource }) => {
  const phases = useMemo(() => resource.attr('planSummaryPhases').resources().list(), [resource]);
  return (
    <FDStack direction="column" spacing={4}>
      {phases.map(phase => (
        <MetaFormInline
          key={phase.id()}
          resource={phase}
          noIndividualSubmitButtons
          component={MetaFormFragmentBase}
          metaOverrideSet={phaseOverrides}
          layout={PlanSummaryPhase}
        />
      ))}
    </FDStack>
  );
};

PlanSummaryPhases.defaultProps = {
};

PlanSummaryPhases.propTypes = {
  resource: PropTypes.object.isRequired,
};
